module.exports = __webpack_public_path__ + "img/7S.82d62864.png";